import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect, useRef } from "react";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import InputMask from "react-input-mask";
import { handleUnauthorized } from "../../../src/utils/apiHelper";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";

const ViewProfileLayer = () => {
 const [imagePreview, setImagePreview] = useState(
    localStorage.getItem("profile_picture") ||
      "assets/images/user-grid/user-grid-img13.png"
  );
 
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
  const userRole =
    localStorage.getItem("user_role") === "super_admin"
      ? "Super Admin"
      : "Sub Admin";
  const [userName, setuserName] = useState("");
  const [userEmail, setuserEmail] = useState("");
  const [userPhone, setuserPhone] = useState("");
  const [userProfile, setProfilePicture] = useState("");
  const [Name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
    const [isImageUploadError, setIsImageUploadError] = useState(false);
    const [isImageUploading, setIsImageUploading] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");

  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  var imgchnage = 0;
  const [activeTab, setActiveTab] = useState("edit-profile");

   const [showRules, setShowRules] = useState(false);
      const [formReady, setFormReady] = useState(false);
      const [passwordRules, setPasswordRules] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false,
        noPersonalInfo: false,
      });
      const validateLive = (oldPass, newPass, confirmPass) => {
  const validationErrors = {};
console.log("Live validation:", { oldPassword, newPassword, confirmPassword });

  const hasLength = newPass.length >= 8 && newPass.length <= 16;
  const hasUpper = /[A-Z]/.test(newPass);
  const hasLower = /[a-z]/.test(newPass);
  const hasNumber = /[0-9]/.test(newPass);
  const hasSpecial = /[!@#$%^&*]/.test(newPass);
  const hasNoPersonalInfo =
    newPass &&
    !newPass.toLowerCase().includes(userEmail?.toLowerCase()) &&
    !newPass.toLowerCase().includes(userName?.toLowerCase()) &&
    !newPass.toLowerCase().includes(userEmail?.split("@")[0]?.toLowerCase());

  const rules = {
    length: hasLength,
    uppercase: hasUpper,
    lowercase: hasLower,
    number: hasNumber,
    special: hasSpecial,
    noPersonalInfo: hasNoPersonalInfo,
  };
  setPasswordRules(rules);

  const allRulesValid = Object.values(rules).every(Boolean);
  const passwordsMatch = newPass === confirmPass;

  if (!oldPass) {
    validationErrors.oldPassword = "Current password is required";
  }
  if (!newPass) {
    validationErrors.newPassword = "New password is required";
  }
  if (!confirmPass) {
    validationErrors.confirmPassword = "Confirm password is required";
  } else if (!passwordsMatch) {
    validationErrors.confirmPassword = "The new password and confirm password does not match";
  }

  setErrors(validationErrors);
  setFormReady(allRulesValid && passwordsMatch && !validationErrors.oldPassword);
  setShowRules(newPass.length > 0);
};
const getRuleClass = (isValid) => (isValid ? "text-success" : "text-danger");
  const navigate = useNavigate();
  const id = localStorage.getItem("admin_id");
  useEffect(() => {
    const fetchAdminData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/adminById/${id}`;
      setLoading(true);
      try {
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) throw new Error("Failed to fetch admin data");
      
        const data = await response.json();
        const profile = data.result.profilePicture || "assets/images/user-grid/user-grid-img13.png";
        setuserName(data.result.name || "");
        setName(data.result.name || "");
        setProfilePicture(profile); // use for view Profile section
        setPhone((data.result.dialCode || "") + (data.result.phone || "")); // use for Edit Profile
        setuserPhone((data.result.dialCode || "") + (data.result.phone || "")); // use for View Phone number
        setuserEmail(data.result.email || "");
        setPhone((data.result.dialCode || "") + (data.result.phone || ""));
        setImagePreview(profile);
      } catch (err) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [id]);

  // Toggle function for password field
  const togglePasswordVisibility = () => setPasswordVisible((prev) => !prev);
  const toggleConfirmPasswordVisibility = () =>
    setConfirmPasswordVisible((prev) => !prev);
  const toggleOldPasswordVisibility = () =>
    setOldPasswordVisible((prev) => !prev);

  const s3Client = new S3Client({
    region: process.env.REACT_APP_AWS_REGION,
    credentials: {
      accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    },
  });

 const uploadToS3 = async (file) => {

    if (!file) return null;
    const fileKey = `temp/${Date.now()}_${file.name}`;
    const params = {
      Bucket: process.env.REACT_APP_AWS_S3_BUCKET_NAME,
      Key: fileKey,
      Body: await file.arrayBuffer(),
      ContentType: file.type,
      ACL: "public-read",
    };
    try {
      const command = new PutObjectCommand(params);
      await s3Client.send(command);
      return `https://${process.env.REACT_APP_AWS_S3_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${fileKey}`;
    } catch (error) {
      console.error("S3 Upload Error:", error);
      throw new Error("Failed to upload file to S3.");
    }
  };
  const newErrors = {};
  const allowedMimeTypes = ["image/png", "image/jpeg", "image/jpg"];

  const readURL = async (event) => {
    
    const file = event.target.files[0];
    if (!file) return;

    const allowedMimeTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (!allowedMimeTypes.includes(file.type)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        profilePicture: "Only PNG and JPG/JPEG files are allowed.",
      }));
      setIsImageUploadError(true);
      return;
    } else {
      setErrors((prevErrors) => {
        const { profilePicture, ...rest } = prevErrors;
        return rest;
      });
      setIsImageUploadError(false);
    }

    // Show immediate preview
    const localUrl = URL.createObjectURL(file);
    setImagePreview(localUrl);

    // Start uploading
    setIsImageUploading(true);

    try {
      const uploadedProfilePicture = await uploadToS3(file);

      setImagePreview(uploadedProfilePicture); // now contains S3 URL
      setIsImageUploadError(false);
    } catch (error) {
      console.error("Error uploading image:", error);
      setErrors((prevErrors) => ({
        ...prevErrors,
        profilePicture: "Failed to upload image. Please try again.",
      }));
      setIsImageUploadError(true);
    } finally {
      setIsImageUploading(false);
    }
  };

  // const allowedMimeTypes = ["image/png", "image/jpeg"];
  const validateInputs = () => {
    if (!Name) newErrors.Name = "Full Name is required";
    if (Name) {
      if (!/^[A-Za-z\s]+$/.test(Name)) {
        newErrors.Name = "Full Name must contain only alphabets";
      }
    }
    if (Name) {
      if (!/^[A-Za-z\s]+$/.test(Name)) {
        newErrors.Name = "Full Name must contain only alphabets";
      }
    }
    if (Name.length < 2 || Name.length > 36) {
      newErrors.Name = "Full Name must be between 2 and 36 characters long";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateInputs()) return;
    setLoading(true);
    let uploadedProfilePicture = imagePreview;
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/updateAdmin`;
    const authToken = localStorage.getItem("authToken");
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          name: Name,
          profilePicture: uploadedProfilePicture,
          timeZone: timeZone,
        }),
      });
      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("name", data.admin.name);
        localStorage.setItem("profile_picture", data.admin.profilePicture);
        setSuccessMessage("Your profile has been updated successfully.");
        setTimeout(() => {
          setSuccessMessage("");
          window.location.reload();
        }, 1000);
      } else {
        setErrorMessage(data.message);
        setLoading(false);
      }
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };
  const validatechangeInputs = () => {
    const newErrors = {};
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/;
    if (!oldPassword) newErrors.oldPassword = "Current password is required";
    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (!passwordRegex.test(newPassword)) {
      newErrors.newPassword =
        "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, and a number";
    }
    if (!confirmPassword)
      newErrors.confirmPassword = "Confirm password is required";
    if (newPassword !== confirmPassword)
      newErrors.confirmPassword =
        "The new password and confirm password must match.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const changehandleSubmits = async (event) => {
    event.preventDefault();
   // if (!validatechangeInputs()) return;
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/adminChangePassword`;
    const authToken = localStorage.getItem("authToken");
    setLoading(true);
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          oldPassword: oldPassword,
          newPassword: newPassword,
          confirmPassword: confirmPassword,
        }),
      });
      const data = await response.json();
        if (!response.ok) {
              setErrors({ oldpPassword:data.message });
          }
        else{
            if (response.ok) 
              {
               console.log(data);
                if(data.status == 403)
                {
                   if(data.message == "New password must be different from current password")
                  {
                      setErrors({ newPassword:data.message });
                  }
                  if(data.message == "Current password is incorrect")
                  {
                      setErrors({ oldPassword:data.message });
                  }
                }
                else
                {
                   setSuccessMessage("Password changed successfully Redirecting...");
                    setOldPasswordVisible("");
                    setConfirmPasswordVisible("");
                    setPasswordVisible("");
                    localStorage.removeItem("authToken");
                    localStorage.removeItem("admin_id");
                    localStorage.removeItem("user_role");
                    localStorage.removeItem("permissions");
                    localStorage.removeItem("profile_picture");
                    localStorage.removeItem("name");
                    sessionStorage.clear(); // Also clear session storage (if used)
                    setTimeout(() => {
                      setLoading(false);
                      navigate("/sign-in");
                    });
                }
                
              }
          };
    } catch (error) {
      setErrorMessage(error?.message || "Something went wrong");
      setTimeout(() => setErrorMessage(""), 3000);
      setActiveTab("change-password");
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    if (loading) return <Loader />;
  }
  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
        <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
          {/* <img
                        src={userProfile}
                        alt=""
                        className="w-100 object-fit-cover"
                    /> */}
          <div className="pb-24 ms-16 mb-24 me-16 ">
            <div className="text-center border border-top-0 border-start-0 border-end-0">
              <img
                src={userProfile}
                alt=""
                className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
              />
              <h6 className="mb-0 mt-16">{userName}</h6>
              <span className="text-secondary-light mb-16">{userEmail}</span>
            </div>
            <div className="mt-24">
              <h6 className="text-xl mb-16">Personal Info</h6>
              <ul>
                <li className=" align-items-center gap-1 mb-12">
                  <span className="w-100 text-md fw-semibold text-primary-light">
                    Full Name
                  </span>
                  <span className="w-100 text-secondary-light fw-medium">
                    {userName}
                  </span>
                </li>
                <li className="align-items-center gap-1 mb-12">
                  <span className="w-100 text-md fw-semibold text-primary-light">
                    {" "}
                    Email
                  </span>
                  <span className="w-100 text-secondary-light fw-medium">
                    {userEmail}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-8">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                className={`nav-link d-flex align-items-center px-24 ${activeTab === "edit-profile" ? "active" : ""}`}
                id="pills-edit-profile-tab"
                type="button"
                role="tab"
                aria-controls="pills-edit-profile"
                aria-selected={activeTab === "edit-profile"}
                onClick={() => setActiveTab("edit-profile")}
                >
                Edit Profile
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                className={`nav-link d-flex align-items-center px-24 ${activeTab === "change-password" ? "active" : ""}`}
                id="pills-change-passwork-tab"
                type="button"
                role="tab"
                aria-controls="pills-change-passwork"
                aria-selected={activeTab === "change-password"}
                onClick={() => setActiveTab("change-password")}
                >
                Change Password
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className={`tab-pane fade ${activeTab === "edit-profile" ? "show active" : ""}`}
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <h6 className="text-md text-primary-light mb-16">
                  Profile Image
                </h6>
                <form action="#" onSubmit={handleSubmit}>
                  {/* Upload Image Start */}
                  <div className="mb-24 mt-16">
                    <div className="avatar-upload">
                      <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                        <input
                          type="file"
                          id="imageUpload"
                          accept=".png, .jpg, .jpeg"
                          hidden
                          onChange={readURL}
                        />
                        <label
                          htmlFor="imageUpload"
                          className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                        >
                          <Icon
                            icon="solar:camera-outline"
                            className="icon"
                          ></Icon>
                        </label>
                      </div>
                      <div className="avatar-preview">
                        <div>
                          <img src={imagePreview}  style={{
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              height: "150px",
                              width: "150px",
                              borderRadius: "50%",
                              border: "1px solid #ccc"
                            }} />
                        </div>
                      </div>
                    </div>
                    {errors.profilePicture && (
                      <p className="text-danger mt-1">
                        {errors.profilePicture}
                      </p>
                    )}
                  </div>
                  {/* Upload Image End */}

                  <div className="row mb-20">
                    <div className="col-sm-6">
                      <div className="">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="name"
                          placeholder="Enter Full Name"
                          value={Name}
                           onChange={(e) => {
                              setName(e.target.value);
                              setErrors((prev) => ({ ...prev, Name: "" }));
                            }}
                            onInput={(e) => {
                              e.target.value = e.target.value
                                .replace(/\s{2,}/g, " ")
                                .trimStart();
                            }}
                          maxLength="36"
                          invalid={!!errors.Name}
                        />
                      </div>
                      {errors.Name && (
                        <p className="text-danger mt-1">{errors.Name}</p>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <div className="">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control radius-8"
                          id="email"
                          placeholder="Enter Email"
                          value={userEmail}
                          disabled
                        />
                      </div>
                    </div>

                    {/* <div className="col-sm-6">
                                            <div className="mb-20">
                                                <label
                                                    htmlFor="number"
                                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                >
                                                    Phone
                                                </label>
                                                <InputMask mask="+9 (999) 999 9999" value={phone} onChange={(e) => setPhone(e.target.value)}>
                                                    {(inputProps) => <input {...inputProps} type="tel" placeholder="Phone"    className="form-control radius-8"/>}
                                                </InputMask>



                                            </div>
                                            {errors.phone && <p className="text-danger mt-1">{errors.phone}</p>}

                                        </div> */}
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-center gap-3"
                    style={{ float: "inline-end" }}
                  >
                   <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      disabled={
                        isImageUploading || isImageUploadError || loading
                      }
                    >
                      {isImageUploading
                        ? "Uploading Image..."
                        : "Update Profile"}
                    </button>
                  </div>
                </form>
              </div>
              <div
                              className={`tab-pane fade ${activeTab === "change-password" ? "show active" : ""}`}
                              id="pills-change-passwork"
                              role="tabpanel"
                              aria-labelledby="pills-change-passwork-tab"
                              tabIndex="0"
                            >
                              <form action="#" onSubmit={changehandleSubmits}>
                                <div className="mb-20">
                                  <label
                                    htmlFor="your-password"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                  >
                                    Current Password{" "}
                                    <span className="text-danger-600">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <input
                                      type={oldPasswordVisible ? "text" : "password"}
                                      className="form-control"
                                      id="old-password"
                                      placeholder="Enter current password"
                                      maxLength="16"
                                      value={oldPassword}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setOldPassword(e.target.value);
                                        validateLive(val,newPassword, confirmPassword);
                                        setErrors((prev) => ({ ...prev, oldPassword: "" }));
                                      
                                      }}
                                    invalid={!!errors.oldPassword}
                                    />

                                    <span
                                      className={`toggle-password ${
                                        oldPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"
                                      } cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                      onClick={toggleOldPasswordVisibility}
                                    ></span>
                                  </div>
                                  {errors.oldPassword && (
                                    <p className="text-danger mt-1">{errors.oldPassword}</p>
                                  )}
                                </div>
                                <div className="mb-20">
                                  <label
                                    htmlFor="your-password"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                  >
                                    New Password <span className="text-danger-600">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <input
                                      type={passwordVisible ? "text" : "password"}
                                      className="form-control"
                                      id="new-password"
                                      placeholder="Enter new password"
                                      maxLength="16"
                                      value={newPassword}
                                      onChange={(e) => {
                                          const val = e.target.value;
                                        setNewPassword(e.target.value);
                                        validateLive(oldPassword,val, confirmPassword);
                                        setErrors((prev) => ({ ...prev, newPassword: "" }));
                                        
                                      }}
                                      onFocus={() => setShowRules(true)}
                                      invalid={!!errors.oldPassword}
                                    />
                                    <span
                                      className={`toggle-password ${
                                        passwordVisible ? "ri-eye-off-line" : "ri-eye-line"
                                      } cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                      onClick={togglePasswordVisibility}
                                    ></span>
                                    
                                  </div>
                                    {showRules && (
                              <ul style={{ fontSize: "12px", paddingLeft: "20px" }}>
                                <li className={getRuleClass(passwordRules.length)}>8–16 characters</li>
                                <li className={getRuleClass(passwordRules.uppercase)}>At least one uppercase letter</li>
                                <li className={getRuleClass(passwordRules.lowercase)}>At least one lowercase letter</li>
                                <li className={getRuleClass(passwordRules.number)}>At least one number</li>
                                <li className={getRuleClass(passwordRules.special)}>At least one special character (!@#$%^&*)</li>
                                <li className={getRuleClass(passwordRules.noPersonalInfo)}>No email/name included</li>
                              </ul>
                            )}
                                  {errors.newPassword && (
                                    <p className="text-danger mt-1">{errors.newPassword}</p>
                                  )}
                                  
                                </div>

                                <div className="mb-20">
                                  <label
                                    htmlFor="confirm-password"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                  >
                                    Confirm New Password{" "}
                                    <span className="text-danger-600">*</span>
                                  </label>
                                  <div className="position-relative">
                                    <input
                                    type={confirmPasswordVisible ? "text" : "password"}
                                    className="form-control"
                                    id="confirm-password"
                                    placeholder="Enter confirm password"
                                    value={confirmPassword}
                                    maxLength="16"
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      setConfirmPassword(val);
                                      let error = "";
                                      if (newPassword !== val) {
                                        error = "The new password and confirm password do not match.";
                                      }

                                      setErrors((prev) => ({
                                        ...prev,
                                        confirmPassword: error,
                                      }));

                                      // Run any live validation logic
                                      validateLive(oldPassword, newPassword, val);
                                    }}
                                  />
                                    <span
                                      className={`toggle-password ${
                                        confirmPasswordVisible
                                          ? "ri-eye-off-line"
                                          : "ri-eye-line"
                                      } cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                      onClick={toggleConfirmPasswordVisibility}
                                    ></span>
                                  </div>
                                  {errors.confirmPassword && (
                                    <p className="text-danger mt-1">
                                      {errors.confirmPassword}
                                    </p>
                                  )}
                                </div>
                                <div
                                  className="d-flex align-items-center justify-content-center gap-3"
                                  style={{ float: "inline-end" }}
                                >
                                  <button
                                    type="submit"
                                    className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                                    disabled={loading || !formReady}
                                  >
                                    {loading ? "Updating Password..." : "Update Password"}
                                  </button>
                                </div>
                              </form>
                        </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProfileLayer;
